export enum D365CaseOriginCode {
    // AssistenteVirtuale = 281820002, <- Non utilizzato, a detta di D365
    Chat = 281820001,
    Telefono = 1,
    Fax = 281820005,
    Email = 2,
    Posta = 281820006,
    Pec = 281820003,
    Web = 3,
    Ivr = 100000000,
    App = 281820007,
    Chatbot = 281820008,
    Ese = 281820009,
    Flagship = 281820010,
    Plenitude = 4,
    Negozi = 281820000,
    AssistenteVirtuale = 100000001,
}
